// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__QFEow","paramInput":"JobSimulator_paramInput__3f5hK","input":"JobSimulator_input__12fQR"};